import { FunctionComponent, useContext, useEffect, useState } from 'react';
import CategoryService from '../../../shared/services/category/category.service';
import GroupService from '../../../shared/services/group/group.service';
import LocationService from '../../../shared/services/location/location.service';
import { IGroupWithCategory } from '../../../shared/services/group/group.model';
import { sortGroupsByGhgCategory, formatGroupLabel } from '../../../shared/constants/ghg-category';
import { ILocation } from '../../../shared/services/location/location.model';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Box, Button, FormControl, FormHelperText, Grid, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent, Stack, Typography } from '@mui/material';
import { ICategory, ICategoryDetail, IMeasurement } from '../../../shared/services/category/category.model';
import { ReportPeriodContext } from '../../../context/report-periods/report-periods';
import { getCategoryDisplayName } from '../../../shared/utils/category-utils';

export const ProductInputFilter:FunctionComponent<{onCancel: () => void, onFoundConversion:(conversion: any) => void}> = ({onCancel, onFoundConversion}) => {
  const categoryService = new CategoryService();
  const groupService = new GroupService();
  const locationService = new LocationService();
  const reportPeriodContext = useContext(ReportPeriodContext)
  const [measurementFilters, setMeasurementFilters] = useState<IMeasurement[]>()
  const [groups, setGroups] = useState<IGroupWithCategory[]>();
  const [groupId, setGroupId] = useState<string>()
  const [category, setCategory] = useState<ICategoryDetail | null>(null);
  const [categories, setCategories] = useState<ICategory[]>()
  const [allowedCategories, setAllowedCategories] = useState<ICategory[]>()
  const [categoryId, setCategoryId] = useState<string>()
  const [locations, setLocations] = useState<ILocation[]>()
  const [selectedData, setSelectedData] = useState<any>({
    detailLevelTwo: '',
    detailLevelThree: '',
    detailLevelFour: '',
    detailLevelFive: ''
  })
  const [filterData, setFilterData] = useState<any>({
    detailLevelTwo: [],
    detailLevelThree: [],
    detailLevelFour: [],
    detailLevelFive: []
  })
  const country = 'United Kingdom'
  const countryId = 'GBR'

  const transactionSchema = Yup.object().shape({
    measurementUnitId: Yup.string().required('You must provide units'),
    unitsConsumed: Yup.number().min(0.01, 'The amount must be greater than 0').required('You must provide an amount'),
    conversionId: Yup.string(),
    groupId: Yup.string(),
    categoryId: Yup.string(),
    locationId: Yup.string().required('Please select a location'),
    additionalInformation: Yup.string(),
    perXProductComponents: Yup.number().required(),
    detailLevelTwo: Yup.string().required('Required'),
    detailLevelThree: Yup.string().nullable(),
    detailLevelFour: Yup.string().nullable(),
    detailLevelFive: Yup.string().nullable(),
  })

  const formik = useFormik<any>({
    initialValues: {
      measurementUnitId: '',
      unitsConsumed: undefined,
      conversionId: '',
      groupId: '',
      categoryId: '',
      additionalInformation: '',
      perXProductComponents: 1,
      locationId: '',
      detailLevelTwo: '',
      detailLevelThree: '',
      detailLevelFour: '',
      detailLevelFive: '',
    },
    validationSchema: transactionSchema,
    onSubmit: (values) => {
      onFoundConversion(values)
    }
  });

  useEffect(() => {
    groupService.getGroupsWithCategories(false)
      .then(response => {
        setGroups(response)
      })
      .catch(err => console.log(err))

    locationService.getActiveLocations()
      .then(response => {
        setLocations(response)
      })
      .catch(err => console.log(err))

    categoryService.getAllCategories()
      .then(response => {
        setCategories(response)
      })
      .catch(err => {
        console.log(err)
      })
  }, [])

  useEffect(() => {
    setSelectedData({
      detailLevelTwo: '',
      detailLevelThree: '',
      detailLevelFour: '',
      detailLevelFive: ''
    })

    setFilterData({
      detailLevelTwo: [],
      detailLevelThree: [],
      detailLevelFour: [],
      detailLevelFive: []
    })

    setCategory(null);
    setMeasurementFilters(undefined);
    // if (categoryId) {
    //   categoryService.getOneCategoryFilter(categoryId, `?reportPeriodId=${reportPeriodContext.lastSelectedOpenReportId}&groupId=${groupId}&countryId=${countryId}`)
    //     .then(response => {
    //       setFilterData({
    //         detailLevelTwo: response.detailLevelTwo ? response.detailLevelTwo : [],
    //         detailLevelThree: response.detailLevelThree ? response.detailLevelThree : [],
    //         detailLevelFour: response.detailLevelFour ? response.detailLevelFour : [],
    //         detailLevelFive: response.detailLevelFive ? response.detailLevelFive : []
    //       });
    //       setSelectedData({ ...selectedData })
    //       formatDataResponse(response, true);
    //     })
    //     .catch(err => {
    //       console.log(err);
    //     })
    // }
  }, [categoryId])

  useEffect(() => {
    if (selectedData.detailLevelTwo && !measurementFilters && categoryId) {
      const queryString = getQueryString(selectedData);
      categoryService.getOneCategoryFilter(categoryId, queryString)
        .then(response => {
          formatDataResponse(response)
          if (response.measurementUnits) {
            setMeasurementFilters(response.measurementUnits)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }, [selectedData])

  function formatDataResponse(response: any, initialCall: boolean = false): void {
    setCategory(response);
    if (!initialCall) {
      const formattedFilters = {
        detailLevelTwo: response.detailLevelTwo?.length !== 1 || filterData.detailLevelTwo?.length === 0 || !filterData.detailLevelTwo ? response.detailLevelTwo : filterData.detailLevelTwo,
        detailLevelThree: response.detailLevelThree?.length !== 1 || filterData.detailLevelThree?.length === 0 || !filterData.detailLevelThree ? response.detailLevelThree : filterData.detailLevelThree,
        detailLevelFour: response.detailLevelFour?.length !== 1 || filterData.detailLevelFour?.length === 0 || !filterData.detailLevelFour ? response.detailLevelFour : filterData.detailLevelFour,
        detailLevelFive: response.detailLevelFive?.length !== 1 || filterData.detailLevelFive?.length === 0 || !filterData.detailLevelFive ? response.detailLevelFive : filterData.detailLevelFive,
      };
      setFilterData({ ...filterData, ...formattedFilters });
    }
    formik.setValues({ ...formik.values })
  }

  function getQueryString(data: any): string {
    let queryString = `?reportPeriodId=${reportPeriodContext.lastSelectedOpenReportId}&groupId=${groupId}`
    for (const [key, value] of Object.entries(data)) {
      queryString += '&'
      if (value) {
        queryString += `${key}=${encodeURIComponent(value as string)}`;
      } else {
        queryString = queryString.substring(0, queryString.length - 1);
      }
    };
    return queryString;
  }
  const selectGroupHandler = (value: string) => {
    formik.setFieldValue('groupId', value);

    if (groupId) {
      const oldGroup = groups?.find(group => group.id === groupId)
      const newGroup = groups?.find(group => group.id === value)

      if (oldGroup?.id !== value) {
        if (newGroup) {
          setAllowedCategories(newGroup.categories)
        }
        formik.setFieldValue('categoryId', '')
        formik.setFieldValue('measurementUnitId', '')
        formik.setFieldValue('unitsConsumed', undefined)
        formik.setFieldValue('locationId', '')
        formik.setFieldValue('conversionId', '')
        formik.setFieldValue('perXProductComponents', 1)
        formik.setFieldValue('conversionId', '')
        formik.setFieldValue('detailLevelTwo', '')
        formik.setFieldValue('detailLevelThree', '')
        formik.setFieldValue('detailLevelFour', '')
        formik.setFieldValue('detailLevelFive', '')
        setCategoryId('')
        setFilterData({});
        setSelectedData({
          detailLevelTwo: '',
          detailLevelThree: '',
          detailLevelFour: '',
          detailLevelFive: ''
        })
      }
    } else {
      const group = groups?.find(group => group.id === value)
      if (group) {
        setAllowedCategories(group.categories)
      }
    }
    setGroupId(value)
  }

  const selectCategoryHandler = (value: string) => {
    formik.setFieldValue('categoryId', value);
    const category = categories?.find(category => category.id === categoryId)
    if (category && category.id !== value) {
      formik.setFieldValue('measurementUnitId', '')
      formik.setFieldValue('unitsConsumed', undefined)
      formik.setFieldValue('locationId', '')
      formik.setFieldValue('perXProductComponents', 1)
      formik.setFieldValue('conversionId', '')
      formik.setFieldValue('detailLevelTwo', '')
      formik.setFieldValue('detailLevelThree', '')
      formik.setFieldValue('detailLevelFour', '')
      formik.setFieldValue('detailLevelFive', '')
      setFilterData({});
      setSelectedData({
        detailLevelTwo: '',
        detailLevelThree: '',
        detailLevelFour: '',
        detailLevelFive: ''
      })
    }
    setCategoryId(value)
  }

  const handleFilterSelect = (e: SelectChangeEvent<string>) => {
    setMeasurementFilters(undefined);
    const stringValue = String(e.target.value);
    const resetData: any = {}
    if (e.target.name === 'detailLevelTwo') {
      resetData.detailLevelThree = '';
      resetData.detailLevelFour = '';
      resetData.detailLevelFive = '';
      formik.setFieldValue('detailLevelThree', '')
      formik.setFieldValue('detailLevelFour', '')
      formik.setFieldValue('detailLevelFive', '')
    };

    if (e.target.name === 'detailLevelThree') {
      resetData.detailLevelFour = '';
      resetData.detailLevelFive = '';
      formik.setFieldValue('detailLevelFour', '')
      formik.setFieldValue('detailLevelFive', '')
    };

    if (e.target.name === 'detailLevelFour') {
      resetData.detailLevelFive = '';
      formik.setFieldValue('detailLevelFive', '')
    };
    formik.setValues({ ...formik.values, ...resetData, [e.target.name]: stringValue })
    setSelectedData({ ...selectedData, ...resetData, [e.target.name]: [e.target.value] })
    setFilterData({ ...filterData, ...resetData })
  }

  const selectMeasurementHandler = async (e: SelectChangeEvent<string>) => {
    const { value } = e.target;
    const queryString = getQueryString({
      ...selectedData,
      measurementUnitId: value,
    });
    if (categoryId) {
      categoryService.getOneCategoryFilter(categoryId, queryString)
        .then(response => {
          formik.setValues({ ...formik.values, measurementUnitId: value, conversionId: response.returnId })
        })
        .catch(err => console.log(err))
    }
    formik.setFieldValue('measurementUnitId', value)
  }

  const selectHandler = (e: SelectChangeEvent<string>) => {
    const { name, value } = e.target;
    const formatted = {
      ...formik.values,
      [name]: value
    }
    formik.setValues(formatted)
  }

  const handleCancel = () => {
    formik.resetForm();
    setSelectedData({
      detailLevelTwo: '',
      detailLevelThree: '',
      detailLevelFour: '',
      detailLevelFive: ''
    })

    setFilterData({
      detailLevelTwo: [],
      detailLevelThree: [],
      detailLevelFour: [],
      detailLevelFive: []
    })
    setCategoryId('')
    setGroupId('')
    setMeasurementFilters([])
    onCancel();
  }

  return (
    <Box>
      {groups && <FormControl fullWidth variant='outlined' sx={{ mt: 2 }}>
        <InputLabel>Group</InputLabel>
        <Select
          label='Group' name='groupId'
          value={formik.values.groupId || ''}
          onChange={(e) => selectGroupHandler(e.target.value)}
          error={formik.touched.groupId && Boolean(formik.errors.groupId)}
          sx={{ color: 'text.primary', }}>
          {sortGroupsByGhgCategory(groups).map((group, index) =>
            <MenuItem key={index} value={group.id}>{formatGroupLabel(group)}</MenuItem>
          )}
        </Select>

      </FormControl>}
      {allowedCategories && <FormControl fullWidth variant='outlined' sx={{ mt: 2 }}>
        <InputLabel htmlFor='categoryId'> Category</InputLabel>
        <Select
          id='categoryId' label='Category' name='categoryId'
          value={formik.values.categoryId}
          onChange={(e) => selectCategoryHandler(e.target.value)}
          error={formik.touched.categoryId && Boolean(formik.errors.categoryId)}
          sx={{ color: 'text.primary', }}>
          {allowedCategories.map((category, index) =>
            <MenuItem key={index} value={category.id}>{getCategoryDisplayName(category)}</MenuItem>
          )}
        </Select>


      </FormControl>}
      <Stack direction='row' spacing={2} sx={{ pb: 1, pt: 2 }}>
        {Object.entries(filterData).filter(value => (value[1] as Array<string>)?.length > 0).map((value, index) => {
          return <FormControl fullWidth variant='outlined' key={index}>
            <Select
              id={value[0]}
              name={value[0]}
              value={selectedData[value[0]] || ''}
              onChange={handleFilterSelect}
              sx={{ color: 'text.secondary' }}>
              {(value[1] as Array<string>)?.map((stringValue, index) =>
                <MenuItem key={index} value={stringValue}>{stringValue}</MenuItem>
              )}
            </Select>
          </FormControl>
        })}
      </Stack>
      {measurementFilters &&
        <>
          <Grid>
            <Stack direction='row' spacing={2} sx={{ mt: 1 }}>
              <FormControl fullWidth variant='outlined' >
                <InputLabel htmlFor='unitsConsumed'>Amount</InputLabel>
                <OutlinedInput inputProps={{ min: 0.01, step: 0.01 }} id='unitsConsumed' label='amount' name='unitsConsumed' type='number'
                  value={formik.values.unitsConsumed} onChange={formik.handleChange}
                  error={formik.touched.unitsConsumed && Boolean(formik.errors.unitsConsumed)}
                  sx={{ color: 'text.secondary' }}></OutlinedInput>
                {formik.touched.unitsConsumed && formik.errors.unitsConsumed &&
                  <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                    {formik.errors.unitsConsumed ? <div>{formik.errors.unitsConsumed as string}</div> : null}
                  </FormHelperText>
                }
              </FormControl>
              <FormControl fullWidth variant='outlined' sx={{ flexBasis: '200px' }}>
                <InputLabel htmlFor='measurementUnitId'> Units</InputLabel>
                <Select
                  id='measurementUnitId' name='measurementUnitId' label='units'
                  value={formik.values.measurementUnitId}
                  onChange={selectMeasurementHandler}
                  error={formik.touched.measurementUnitId && Boolean(formik.errors.measurementUnitId)}
                  sx={{ color: 'text.secondary' }}>
                  {measurementFilters?.map((measurementFilter, index) =>
                    <MenuItem key={index} value={measurementFilter.id}>{measurementFilter.name}</MenuItem>
                  )}
                </Select>
                {formik.touched.measurementUnitId && formik.errors.measurementUnitId &&
                  <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                    {formik.errors.measurementUnitId ? <div>{formik.errors.measurementUnitId as string}</div> : null}
                  </FormHelperText>
                }
              </FormControl>
              <FormControl fullWidth variant='outlined' sx={{ flexBasis: '200px' }}>
                <InputLabel>Per X components</InputLabel>
                <OutlinedInput inputProps={{ min: 0.01, step: 0.01 }} label='Per X components' name='perXProductComponents' type='number'
                  value={formik.values.perXProductComponents || ''} onChange={formik.handleChange}
                  error={formik.touched.perXProductComponents && Boolean(formik.errors.perXProductComponents)}
                  sx={{ color: 'text.secondary' }}></OutlinedInput>
              </FormControl>
            </Stack>
            <FormControl fullWidth variant='outlined' sx={{ mb: 1, mt: 2 }}>
              <InputLabel htmlFor='locationId'> Location</InputLabel>
              <Select
                id='locationId' label='locationId' name='locationId'
                value={formik.values.locationId}
                onChange={selectHandler}
                error={formik.touched.locationId && Boolean(formik.errors.locationId)}
                sx={{ color: 'text.secondary', }}>
                {locations?.sort((a, b) => a.friendlyName.localeCompare(b.friendlyName)).map((location, index) =>
                  <MenuItem key={index} value={location.id}>{location.friendlyName}</MenuItem>
                )}
              </Select>
              {formik.touched.locationId && formik.errors.locationId &&
                <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                  {formik.errors.locationId ? <div>{formik.errors.locationId as string}</div> : null}
                </FormHelperText>
              }
            </FormControl>
          </Grid>
        </>}

      <Stack sx={{ display: 'flex', flexDirection: 'row', mb: 2, mt: 2 }}>
        <Box sx={{ mr: 2 }}>
          <Button variant='text' onClick={handleCancel} >
            <Typography sx={{ color: 'primary.main' }}>Cancel </Typography>
          </Button>
        </Box>
        <Button onClick={formik.submitForm} disabled={formik.values.conversionId === '' && formik.values.locationId === ''}>
          <Typography>Save</Typography>
        </Button>
      </Stack>
    </Box>
  )
}